import { render, staticRenderFns } from "./over.vue?vue&type=template&id=1f50df24&scoped=true"
import script from "./over.vue?vue&type=script&lang=js"
export * from "./over.vue?vue&type=script&lang=js"
import style0 from "./over.vue?vue&type=style&index=0&id=1f50df24&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f50df24",
  null
  
)

export default component.exports